import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const CustomerService = (() => {
  const service = {};
  const BASE_URL = Environment.getBaseURL();

  const updateUsername = ({ toUsername, fromUsername, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/customer/username`,
      {
        toUsername,
        fromUsername,
      },
      {
        headers,
      }
    );
  };

  const removeUser = ({ username, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/customer/remove`,
      {
        username,
      },
      {
        headers,
      }
    );
  };

  const resetPassword = ({ username, appId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/customer/forgot-password`,
      {
        username,
        appId,
      },
      {
        headers,
      }
    );
  };

  const getLinkedCustomers = (customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/customer/link/${customerId}`, {
      headers,
    });
  };

  const linkCustomers = (customerId, customerIdToLink, athosUserId, reason) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.post(
      `${BASE_URL}/customer/link`,
      {
        customerId,
        customerIdToLink,
        athosUserId,
        reason,
      },
      {
        headers,
      }
    );
  };

  const unlinkCustomers = (customerId, customerIdToLink, athosUserId, reason) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/customer/unlink`,
      {
        customerId,
        customerIdToLink,
        athosUserId,
        reason,
      },
      {
        headers,
      }
    );
  };

  const getLinkedCustomersHistory = (customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/customer/link/history/${customerId}`, {
      headers,
    });
  };

  const copyDocuments = ({ fromCustomerId, toCustomerId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/customer/documents/copy`,
      {
        fromCustomerId,
        toCustomerId,
      },
      {
        headers,
      }
    );
  };

  const getCustomers = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const { customerId, } = criteria;
    const { username, } = criteria;
    if (typeof customerId !== 'undefined' && customerId) {
      return axios.get(`${BASE_URL}/customer/customerDataByCustomerId/${customerId}`, {
        headers,
      });
    }
    return axios.get(`${BASE_URL}/customer/customerDataByEmail/${username}`, {
      headers,
    });
  };

  const getCustomerDetail = (id) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/customer/customerDataByCustomerId/${id}`, {
      headers,
    });
  };

  service.getCustomers = getCustomers;
  service.getCustomerDetail = getCustomerDetail;
  service.updateUsername = updateUsername;
  service.removeUser = removeUser;
  service.copyDocuments = copyDocuments;
  service.resetPassword = resetPassword;
  service.getLinkedCustomers = getLinkedCustomers;
  service.linkCustomers = linkCustomers;
  service.unlinkCustomers = unlinkCustomers;
  service.getLinkedCustomersHistory = getLinkedCustomersHistory;
  return service;
})();

export default CustomerService;
